import { createContext, useContext } from "react";

export const AclContext = createContext(null);
export const useAcl = () => useContext(AclContext);
